<template>
  <div class="page-wrapper">
    <div style="display: flex; justify-content: center;  flex-flow: column; align-items: center; margin-top: 40px">
      <img class="block-center" src="/images/404.png" alt="404 images" width="454" />

      <p class="mt-24 text-uppercase text-medium">{{ $lang.messages.page_missing }}</p>
      <p class="text-uppercase text-medium">{{ $lang.messages.page_missing_content }}</p>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    const locale = window.localStorage.getItem('locale') || 'en'
    this.$lang.setLang(locale)
  }
}
</script>
